import { ImageSizeType, BASE_URI } from '../config';

/**
 * Bumped whenever the bytes served for a given (asset, modality) URL change
 * meaningfully — e.g. when slice thumbnails switched from raw DICOM to JPEG
 * derivatives. The download endpoint answers with long-lived `immutable`
 * cache headers, so old entries never revalidate on their own.
 */
const IMAGE_URL_VERSION = '2';

export const getImageSrc = (
  imageID: string | undefined,
  imageSize: ImageSizeType,
): string =>
  imageID
    ? `${BASE_URI}/api/storage/download/image/${imageSize}/${imageID}?v=${IMAGE_URL_VERSION}`
    : '';
